"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardBadge = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _PropertyCardBadge = require("./PropertyCardBadge.styles");
var _excluded = ["appearance", "children"];
/**
 * Used by `PropertyCard` to highlight a particular piece of information
 * about a property. By default, the badge appears in the top-left corner of the card,
 * atop the property photo.
 *
 * @since 8.63.0
 */
var PropertyCardBadge = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var appearance = _ref.appearance,
    children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_PropertyCardBadge.StyledPropertyCardBadge, (0, _extends2.default)({
    appearance: appearance,
    ref: forwardedRef
  }, rest), children);
});
exports.PropertyCardBadge = PropertyCardBadge;
PropertyCardBadge.displayName = 'PropertyCard.Badge';
PropertyCardBadge.propTypes = {
  /**
   * Determines the color of the badge.
   */
  appearance: _propTypes.default.oneOf(Object.values(_constants.PROPERTY_CARD_BADGE_APPEARANCES)),
  /**
   * Can include an `Icon`.
   */
  children: _propTypes.default.node
};
PropertyCardBadge.defaultProps = {
  appearance: 'default'
};